import React from "react";

const HelpAndSupport = React.lazy(() => import("../screens/Dashboard/Profile/HelpAndSupport"));
const Home = React.lazy(() => import("../screens/Dashboard"));
const ModeratorPointTransfer = React.lazy(() => import("../screens/Dashboard/ModeratorPointTransfer/ModeratorPointTransfer.js"));
const KycModerator = React.lazy(() => import("../screens/Dashboard/KycModerator/KycModerator.js"));
const QuizHistory = React.lazy(() => import("../components/Dashboard/QuizHistory/QuizHistory.js"));
const Opponent = React.lazy(() => import("../components/Dashboard/Opponent/Opponent.js"));
const QuizQuestionPage = React.lazy(() => import("../components/Dashboard/QuizQuestionPage/QuizQuestionPage.js"));
const QuizResult = React.lazy(() => import("../components/Dashboard/QuizResult/QuizResult.js"));
const AllEarningMethods = React.lazy(() => import("../screens/AllPointMysteryBox/AllEarningMethod.js"));
const ReferralScreen = React.lazy(() => import("../screens/Dashboard/Referral.js"));
const VsScreen = React.lazy(() => import("../components/Dashboard/QuizVsScreen/VsScreen.js"));
const RankProgressScreen = React.lazy(() => import("../screens/Dashboard/LeaderBoard/MyRank.js"));
const UserRankStatisticsScreen = React.lazy(() => import("../screens/Dashboard/LeaderBoard/OtherUserRank.js"));
const ReferralLeaderBoard = React.lazy(() => import("../screens/Dashboard/LeaderBoard/ReferralLeaderBoard.js"));
const QuizLeaderBoard = React.lazy(() => import("../screens/Dashboard/LeaderBoard/QuizLeaderBoard.js"));
const OfferwallLeaderBoard = React.lazy(() => import("../screens/Dashboard/LeaderBoard/OfferwallLeaderBoard.js"));
const SocialThread = React.lazy(() => import("../screens/Social/SocialThread.js"));
const PointAnalytics = React.lazy(() => import("../screens/Dashboard/LeaderBoard/AllPointHistory/PointAnalytics.js"));
const AllPointMysteryBox = React.lazy(() => import("../screens/AllPointMysteryBox/AllPointMysteryBox.js"));
const Task = React.lazy(() => import("../screens/Dashboard/Task"));
const Wallet = React.lazy(() => import("../screens/Dashboard/Wallet"));
const AllTaskStatus = React.lazy(() =>
  import("../screens/Dashboard/Task/AllTaskStatus/AllTaskStatus")
);

const ChatScreenBottom = React.lazy(() =>
  import("../screens/Chats/ChatScreenBottom.js")
)
const MyTransactions = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw/SendWithdraw/MyTrasaction.js")
);
const Audit = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw/Audit/Audit.js")
);

const ChatModeratorScreen = React.lazy(() =>
  import("../screens/Chats/ChatModeratorScreen.js")
)

const ChatWindowModerator = React.lazy(() =>
  import("../screens/Chats/ChatWindowModerator.js")
)
const AutomatedMessagesList = React.lazy(() =>
  import("../screens/Chats/AutomatedMessagesList.js")
)
const ManageAutomatedMessage = React.lazy(() =>
  import("../screens/Chats/ManageAutomatedMessage.js")
)
const AuditDetails = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw/Audit/AuditDetails.js")
);
// /home/MyTransactions
const Earning = React.lazy(() => import("../screens/Dashboard/Earnings"));
const RedeemCoupon = React.lazy(() =>
  import("../screens/Dashboard/Wallet/RedeemCoupon")
);
const MyAssignTrasaction = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw/SendWithdraw/MyTrasaction.js")
);
const RedeemINR = React.lazy(() =>
  import("../screens/Dashboard/Wallet/RedeemPoints/RedeemINR/RedeemINR.js")
);
const Referral = React.lazy(() =>
  import("../screens/Dashboard/Referral/Referral")
);
const ReferralPurchaseHistory = React.lazy(() =>
  import(
    "../screens/Dashboard/Referral/ReferralPurchaseHistory/ReferralPurchaseHistory"
  )
);
const Withdraw = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw")
);

const SendWithdrawSelect = React.lazy(() =>
  import(
    "../screens/Dashboard/Wallet/withdraw/SendWithdraw/SendWithdrawSelect.js"
  )
);
// Social Media Task

const SocialMediaTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/SocialMediaTask")
);
const FacebookTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/FacebookTask")
);
const InstagramTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/InstagramTask")
);

const TelegramTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/TelegramTask")
);
const TwitterTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/TwitterTask")
);
const YoutubeTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/YoutubeTask")
);
// const WhatsAppTask = React.lazy(() =>
//   import("../screens/Dashboard/SocialMediaTask/WhatsAppTask")
// );
const ReviewTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/ReviewTask")
);
const OthersTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/OthersTask")
);
const TaskDetails = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/TaskDetails")
);
const Premium = React.lazy(() => import("../screens/Dashboard/Premium"));
const Success = React.lazy(() =>
  import("../screens/Dashboard/Premium/Payment Status/Success")
);
const Failiure = React.lazy(() =>
  import("../screens/Dashboard/Premium/Payment Status/Failiure")
);
const MyLeads = React.lazy(() => import("../screens/Dashboard/MyLeads"));
const AllPointHistory = React.lazy(() =>
  import("../screens/Dashboard/LeaderBoard/AllPointHistory/AllPointHistory")
);
const TaskPointHistory = React.lazy(() =>
  import("../screens/Dashboard/Wallet/TaskPoint/TaskPointHistory.js")
);
const MyProfile = React.lazy(() =>
  import("../screens/Dashboard/Profile/MyProfile")
);
const ChatWithUs = React.lazy(() =>
  import("../screens/Chats/ChatWithUs/ChatWithUs")
);
const ManagePayment = React.lazy(() =>
  import("../screens/Dashboard/Profile/ManagePayment/ManagePayment")
);
const KYC = React.lazy(() => import("../screens/Dashboard/Profile/KYC/KYC"));
const LeaderBoard = React.lazy(() =>
  import("../screens/Dashboard/LeaderBoard")
);
const MysteryBox = React.lazy(() =>
  import("../screens/Dashboard/LeaderBoard/MysteryBox")
);
const LeaderBoardHistory = React.lazy(() =>
  import("../screens/Dashboard/LeaderBoard/LeaderBoardHistory")
);
const CreateTask = React.lazy(() => import("../screens/Dashboard/CreateTask"));
const CreateTaskForm = React.lazy(() =>
  import("../screens/Dashboard/CreateTask/CreateTaskForm")
);
const DepositMethod = React.lazy(() =>
  import("../screens/Dashboard/Deposit/DepositMethod/DepositMethod")
);
const ShowHistory = React.lazy(() =>
  import("../screens/Dashboard/CreateTask/ShowHistory")
);

const ManageTask = React.lazy(() => import("../screens/Dashboard/ManageTask"));
const ManageCreatedTasks = React.lazy(() =>
  import("../screens/Dashboard/Task/ManageCreatedTasks/ManageCreatedTasks")
);
const AllSubmissions = React.lazy(() =>
  import("../screens/Dashboard/Task/AllSubmissions/AllSubmissions")
);

const PaymentMethod = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethod/PaymentMethod")
);
const PremiumMethod = React.lazy(() =>
  import("../screens/Dashboard/Premium/UpdatedPremiumMethod/PremiumMethod.js")
);
const PremiumBankTransfer = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethods/PremiumBankTransfer")
);
const PremiumUPITransfer = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethods/PremiumUPITransfer")
);
const PremiumUSDTTransfer = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethods/PremiumUSDTTransfer")
);
const PremiumGPayTransfer = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethods/PremiumGPayTransfer")
);
const PremiumPaytmTransfer = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethods/PremiumPaytmTransfer")
);
const PremiumPhonePeTransfer = React.lazy(() =>
  import("../screens/Dashboard/Premium/PaymentMethods/PremiumPhonePeTransfer")
);

const RedeemPoints = React.lazy(() =>
  import("../screens/Dashboard/Wallet/RedeemPoints/RedeemPoints")
);
const ChangePassword = React.lazy(() =>
  import("../screens/Dashboard/Profile/ChangePassword/ChangePassword")
);

const About = React.lazy(() => import("../screens/About/About"));
const AboutUs = React.lazy(() => import("../screens/About/AboutUs/AboutUs"));
const FAQ = React.lazy(() => import("../screens/FAQ/FAQ"));
const SeeMore = React.lazy(() => import("../screens/FAQ/SeeMore"));
const PrivacyPolicy = React.lazy(() =>
  import("../screens/About/PrivacyPolicy/PrivacyPolicy")
);
const RefundPolicy = React.lazy(() =>
  import("../screens/About/RefundPolicy/RefundPolicy")
);
const TermsAndConditions = React.lazy(() =>
  import("../screens/About/TermsAndConditions/TermsAndConditions")
);
const ContactUs = React.lazy(() =>
  import("../screens/About/ContactUs/ContactUs")
);
const Feedback = React.lazy(() => import("../screens/About/Feedback/Feedback"));
// 404
const Page404 = React.lazy(() => import("../screens/Page404"));
const CreateTaskStatus = React.lazy(() =>
  import("../screens/Dashboard/CreateTask/CreateTaskStatus/CreateTaskStatus")
);
const CreatedTaskHistory = React.lazy(() =>
  import("../screens/Dashboard/Task/AllTaskHistory/CreatedTaskHistory")
);
const AddSocialMediaHandle = React.lazy(() =>
  import(
    "../screens/Dashboard/Profile/AddSocialMediaHandle/AddSocialMediaHandle"
  )
);
const IndividualTask = React.lazy(() =>
  import("../screens/Dashboard/SocialMediaTask/IndividualTask/IndividualTask")
);
const StakePoints = React.lazy(() =>
  import("../screens/Dashboard/StakePoints/StakePoints")
);
const NotificationScreen = React.lazy(() =>
  import("../screens/Dashboard/Notification/NotificationScreen")
);
const DailyStreak = React.lazy(() =>
  import("../screens/Dashboard/DailyStreak/DailyStreak")
);
const TradeHomeScreen = React.lazy(() =>
  import("../screens/Dashboard/Trade/TradeHomeScreen")
);

const TradeLiveScreen = React.lazy(() =>
  import("../screens/Dashboard/Trade/TradeLiveScreen")
);
const TradeLeagueScreen = React.lazy(() =>
  import("../screens/Dashboard/Trade/TradeLeagueScreen")
);
const DetailTradeScreen = React.lazy(() =>
  import("../screens/Dashboard/Trade/DetailTradeScreen")
);
const PollParticipationHistory = React.lazy(() =>
  import(
    "../screens/Dashboard/Trade/PollParticipationHistory/PollParticipationHistory"
  )
);
const SubmitWithdrawProof = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw/WithdrawProof")
);
const SendWithdraw = React.lazy(() =>
  import("../screens/Dashboard/Wallet/withdraw/SendWithdraw/SendWithdraw")
);

const buyReferrals = React.lazy(() =>
  import("../screens/Dashboard/Referral/buyReferrals")
);
const BuyReferralPage = React.lazy(() =>
  import("../screens/Dashboard/BuyReferral/BuyReferralPage")
);
const TaskChat = React.lazy(() => import("../screens/Chats/chat.js"));
const ChatWithCreator = React.lazy(() =>
  import("../screens/Chats/creatorChat.js")
);
const ChatAsCreator = React.lazy(() =>
  import("../screens/Chats/chatAsCreator.js")
);
const ActiveRefferUsers = React.lazy(() =>
  import("../screens/Dashboard/Referral/ActiveReferral/ActiveRefferUsers.js")
);
const Social = React.lazy(() =>
  import("../screens/Social/Social")
);

const SocialComments = React.lazy(() =>
  import("../screens/Social/Comments")
);

const SocialUserProfile = React.lazy(() =>
  import("../screens/Social/UserProfile")
);

const SocialSearchScreen = React.lazy(() =>
  import("../screens/Social/SocialSearchScreen")
);

const FollowListPage = React.lazy(() =>
  import("../screens/Social/FollowerListPage")
);

// User-to-User Chat
const AllUserChatsScreen = React.lazy(() =>
  import("../screens/Chats/UserChat/AllUserChatsScreen")
);

const UserToUserChatScreen = React.lazy(() =>
  import("../screens/Chats/UserChat/UserToUserChatScreen")
);

// Platform Listing Web Pages
const PlatformListing = React.lazy(() => import("../screens/PlatformListing/PlatformListing"));
const AddNewPlatform = React.lazy(() => import("../screens/PlatformListing/AddNewPlatform"));
const CompletePlatformDetails = React.lazy(() => import("../screens/PlatformListing/CompletePlatformDetails"));
const ReviewPlatformPreview = React.lazy(() => import("../screens/PlatformListing/ReviewPlatformPreview"));
const PlatformDetails = React.lazy(() => import("../screens/PlatformListing/PlatformDetails"));
const AddReferralLink = React.lazy(() => import("../screens/PlatformListing/AddReferralLink"));
const PlatformReferralLinksList = React.lazy(() => import("../screens/PlatformListing/PlatformReferralLinksList"));
const MyReferralLinks = React.lazy(() => import("../screens/PlatformListing/MyReferralLinks"));
const UserPortfolio = React.lazy(() => import("../screens/PlatformListing/UserPortfolio"));
const CommunityChat = React.lazy(() => import("../screens/PlatformListing/CommunityChat"));
const PlatformModerator = React.lazy(() => import("../screens/PlatformListing/PlatformModerator"));

const DematTaskHome = React.lazy(() =>
  import("../screens/Dashboard/DematTask/DematTaskHome")
);
const DematTaskDetail = React.lazy(() =>
  import("../screens/Dashboard/DematTask/DematTaskDetail")
);

export const routers = [
  {
    path: "/",
    exact: true,
    name: "Dashboard",
    permission: ["user"],
    component: Home,
  },
  {
    path: "*",
    exact: true,
    name: "Error",
    permission: ["user"],
    component: Page404,
  },
  {
    path: "/withdraw/MyTransactions",
    exact: true,
    name: "MyTransaction",
    permission: ["user"],
    component: MyTransactions,
  },
  {
    path: "/withdraw/Audit",
    exact: true,
    name: "Audit",
    permission: ["user"],
    component: Audit,
  },
  {
    path: "/withdraw/Audit/Details",
    exact: true,
    name: "Audit Details",
    permission: ["user"],
    component: AuditDetails,
  },
  {
    path: "/task",
    exact: true,
    name: "Task",
    permission: ["user"],
    component: Task,
  },
  {
    path: "/wallet",
    exact: true,
    name: "Wallet",
    permission: ["user"],
    component: Wallet,
  },
  {
    path: "/earning",
    exact: true,
    name: "Earning",
    permission: ["user"],
    component: Earning,
  },
  {
    path: "/redeem-coupon",
    exact: true,
    name: "Redeem Coupon",
    permission: ["user"],
    component: RedeemCoupon,
  },
  {
    path: "/daily-streak",
    exact: true,
    name: "Daily Streak",
    permission: ["user"],
    component: DailyStreak,
  },
  {
    path: "/demat",
    exact: true,
    name: "Demat Tasks",
    permission: ["user"],
    component: DematTaskHome,
  },
  {
    path: "/demat/:taskId",
    exact: true,
    name: "Demat Task Details",
    permission: ["user"],
    component: DematTaskDetail,
  },
  {
    path: "/redeem-inr",
    exact: true,
    name: "Redeem INR",
    permission: ["user"],
    component: RedeemINR,
  },

  {
    path: "/MyAssignTrasaction",
    exact: true,
    name: "My Assigned Trasaction",
    permission: ["user"],
    component: MyAssignTrasaction,
  },
  {
    path: "/referral",
    exact: true,
    name: "Referral",
    permission: ["user"],
    component: Referral,
  },
  {
    path: "/withdraw",
    exact: true,
    name: "Withdraw",
    permission: ["user"],
    component: Withdraw,
  },
  {
    path: "/moderatorwithdraw",
    exact: true,
    name: "SendWithdrawSelect",
    permission: ["user"],
    component: SendWithdrawSelect,
  },
  {
    path: "/kyc-moderator",
    exact: true,
    name: "KycModerator",
    permission: ["user"],
    component: KycModerator,
  },
  {
    path: "/platform-moderator",
    exact: true,
    name: "PlatformModerator",
    permission: ["user"],
    component: PlatformModerator,
  },
  // Social Media Task QuizResult
  {
    path: "/QuizResult",
    exact: true,
    name: "QuizResult",
    permission: ["user"],
    component: QuizResult,
  },
  {
    path: "/social-media-task",
    exact: true,
    name: "Social Media Task",
    permission: ["user"],
    component: SocialMediaTask,
  },
  {
    path: "/facebook-task",
    exact: true,
    name: "Facebook Task",
    permission: ["user"],
    component: FacebookTask,
  },
  {
    path: "/instagram-task",
    exact: true,
    name: "Instagram Task",
    permission: ["user"],
    component: InstagramTask,
  },
  {
    path: "/telegram-task",
    exact: true,
    name: "Telegram Task",
    permission: ["user"],
    component: TelegramTask,
  },

  {
    path: "/youtube-task",
    exact: true,
    name: "Youtube Task",
    permission: ["user"],
    component: YoutubeTask,
  },
  {
    path: "/twitter-task",
    exact: true,
    name: "Twitter Task",
    permission: ["user"],
    component: TwitterTask,
  },
  // {
  //   path: "/whatsapp-task",
  //   exact: true,
  //   name: "WhatsApp Task",
  //   permission: ["user"],
  //   component: WhatsAppTask,
  // },
  {
    path: "/reviews-task",
    exact: true,
    name: "Review Task",
    permission: ["user"],
    component: ReviewTask,
  },
  {
    path: "/all-tasks-status",
    exact: true,
    name: "All Tasks Status",
    permission: ["user"],
    component: AllTaskStatus,
  },
  {
    path: "/others-task",
    exact: true,
    name: "Others Task",
    permission: ["user"],
    component: OthersTask,
  },
  {
    path: "/task-details",
    exact: true,
    name: "Task Details",
    permission: ["user"],
    component: TaskDetails,
  },
  {
    path: "/premium",
    exact: true,
    name: "Premium",
    permission: ["user"],
    component: Premium,
  },
  {
    path: "/premium/payment-method",
    exact: true,
    name: "Premium Payment Method",
    permission: ["user"],
    // component: PaymentMethod,
    component: PremiumMethod,
  },
  {
    path: "/premium/bank-transfer",
    exact: true,
    name: "Premium Bank Transfer",
    permission: ["user"],
    component: PremiumBankTransfer,
  },
  {
    path: "/premium/upi-transfer",
    exact: true,
    name: "Premium UPI Transfer",
    permission: ["user"],
    component: PremiumUPITransfer,
  },
  {
    path: "/premium/usdt-transfer",
    exact: true,
    name: "Premium USDT Transfer",
    permission: ["user"],
    component: PremiumUSDTTransfer,
  },
  {
    path: "/premium/gpay-transfer",
    exact: true,
    name: "Premium GPay Transfer",
    permission: ["user"],
    component: PremiumGPayTransfer,
  },
  {
    path: "/premium/paytm-transfer",
    exact: true,
    name: "Premium Paytm Transfer",
    permission: ["user"],
    component: PremiumPaytmTransfer,
  },
  {
    path: "/premium/phonepe-transfer",
    exact: true,
    name: "Premium PhonePe Transfer",
    permission: ["user"],
    component: PremiumPhonePeTransfer,
  },
  {
    path: "/premium/payment-status/success",
    exact: true,
    name: "Payment Successfull",
    permission: ["user"],
    component: Success,
  },
  {
    path: "/premium/payment-status/failiure",
    exact: true,
    name: "Payment Failed",
    permission: ["user"],
    component: Failiure,
  },
  {
    path: "/my-leads",
    exact: true,
    name: "My Leads",
    permission: ["user"],
    component: MyLeads,
  },
  {
    path: "/all-point-history",
    exact: true,
    name: "All Point History",
    permission: ["user"],
    component: AllPointHistory,
  },

  {
    path: "/task-point-history",
    exact: true,
    name: "Task Point History",
    permission: ["user"],
    component: TaskPointHistory,
  },
  {
    path: "/quizhistory",
    exact: true,
    name: "Quiz Hispory",
    permission: ["user"],
    component: QuizHistory,
  },
  // /home/randomoppone
  {
    path: "/randomopponent",
    exact: true,
    name: "randomopponent",
    permission: ["user"],
    component: Opponent,
  },
  {
    path: "/quizquestion",
    exact: true,
    name: "QuizQuestionPage",
    permission: ["user"],
    component: QuizQuestionPage,
  },
  {
    path: "/vsscreen",
    exact: true,
    name: "QuizQuestionPage",
    permission: ["user"],
    component: VsScreen,
  },
  {
    path: "/my-profile",
    exact: true,
    name: "My Profile",
    permission: ["user"],
    component: MyProfile,
  },
  {
    path: "/help-and-support",
    exact: true,
    name: "Help and Support",
    permission: ["user"],
    component: HelpAndSupport,
  },
  {
    path: "/chat-with-us",
    exact: true,
    name: "Chat with US",
    permission: ["user"],
    component: ChatWithUs,
  },
  {
    path: "/chat-screen-bottom",
    exact: true,
    name: "Chat Screen Bottom",
    permission: ["user"],
    component: ChatScreenBottom,
  },
  {
    path: "/chat-moderator",
    exact: true,
    name: "Chat Moderator",
    // Add 'admin' or your specific moderator role here
    permission: ["user", "admin", "moderator"],
    component: ChatModeratorScreen,
  },
  {
    path: "/chat-window-moderator",
    exact: true,
    name: "Chat Window",
    // Add 'admin' or your specific moderator role here
    permission: ["user", "admin", "moderator"],
    component: ChatWindowModerator,
  },
  {
    path: "/automated-messages-list",
    exact: true,
    name: "Automated Messages",
    permission: ["user", "admin", "moderator"],
    component: AutomatedMessagesList,
  },
  {
    path: "/manage-automated-message",
    exact: true,
    name: "Manage Automated Message",
    permission: ["user", "admin", "moderator"],
    component: ManageAutomatedMessage,
  },
  {
    path: "/my-profile/manage-payment",
    exact: true,
    name: "Manage Payment",
    permission: ["user"],
    component: ManagePayment,
  },
  {
    path: "/my-profile/kyc",
    exact: true,
    name: "KYC",
    permission: ["user"],
    component: KYC,
  },
  {
    path: "/my-profile/change-password",
    exact: true,
    name: "Change Password",
    permission: ["user"],
    component: ChangePassword,
  },
  {
    path: "/leader-board",
    exact: true,
    name: "Leader Board data",
    permission: ["user"],
    component: LeaderBoard,
  },
  {
    path: "/mystery-box",
    exact: true,
    name: "Watch & Earn",
    permission: ["user"],
    component: AllPointMysteryBox,
  },
  {
    path: "/all-earning-methods",
    exact: true,
    name: "All Earning Methods",
    permission: ["user"],
    component: AllEarningMethods,
  },
  {
    path: "/Referral-Screen",
    exact: true,
    name: "Referral Screen",
    permission: ["user"],
    component: ReferralScreen,
  },
  {
    path: "/leader-board-history",
    exact: true,
    name: "Leader Board History",
    permission: ["user"],
    component: LeaderBoardHistory,
  },
  {
    path: "/ModeratorPointTransfer",
    exact: true,
    name: "ModeratorPointTransfer ",
    permission: ["user"],
    component: ModeratorPointTransfer,
  },
  {
    path: "/get-my-rank",
    exact: true,
    name: "GetMyRank ",
    permission: ["user"],
    component: RankProgressScreen,
  },
  {
    path: "/get-rank",
    exact: true,
    name: "GetUserRank ",
    permission: ["user"],
    component: UserRankStatisticsScreen,
  },
  // quiz-leaderboard
  {
    path: "/quiz-leaderboard",
    exact: true,
    name: "Quiz Leader Board",
    permission: ["user"],
    component: QuizLeaderBoard,
  },
  {
    path: "/referral-leader-board",
    exact: true,
    name: "Referral Leader Board",
    permission: ["user"],
    component: ReferralLeaderBoard,
  },
  {
    path: "/offerwall-leaderboard",
    exact: true,
    name: "Offerwall Leader Board",
    permission: ["user"],
    component: OfferwallLeaderBoard,
  },
  {
    path: "/promote",
    exact: true,
    name: "Create Task",
    permission: ["user"],
    component: CreateTask,
  },
  {
    path: "/promote/:taskProfile/:taskSubProfile/:autoFillLimit",
    exact: true,
    name: "Create Task",
    permission: ["user"],
    component: CreateTask,
  },
  {
    path: "/create-task-form",
    exact: true,
    name: "Create Task Form",
    permission: ["user"],
    component: CreateTaskForm,
  },
  {
    path: "/deposit-method",
    exact: true,
    name: "Deposit Method",
    permission: ["user"],
    component: DepositMethod,
  },
  {
    path: "/show-history",
    exact: true,
    name: "Show History",
    permission: ["user"],
    component: ShowHistory,
  },
  {
    path: "/manage-task",
    exact: true,
    name: "Manage Task",
    permission: ["user"],
    component: ManageTask,
  },
  {
    path: "/redeem-points",
    exact: true,
    name: "Redeem Points",
    permission: ["user"],
    component: RedeemPoints,
  },
  {
    path: "/about",
    exact: true,
    name: "About",
    permission: ["user"],
    component: About,
  },
  {
    path: "/about-us",
    exact: true,
    name: "About Us",
    permission: ["user"],
    component: AboutUs,
  },
  {
    path: "/FAQ",
    exact: true,
    name: "FAQ",
    permission: ["user"],
    component: FAQ,
  },
  {
    path: "/FAQ/SeeMore",
    exact: true,
    name: "SeeMore",
    permission: ["user"],
    component: SeeMore,
  },
  {
    path: "/privacy-policy",
    exact: true,
    name: "Privacy Policy",
    permission: ["user"],
    component: PrivacyPolicy,
  },
  {
    path: "/refund-policy",
    exact: true,
    name: "Refund Policy",
    permission: ["user"],
    component: RefundPolicy,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    name: "Terms And Conditions",
    permission: ["user"],
    component: TermsAndConditions,
  },
  {
    path: "/contact-us",
    exact: true,
    name: "Contact Us",
    permission: ["user"],
    component: ContactUs,
  },
  {
    path: "/feedback",
    exact: true,
    name: "Feedback",
    permission: ["user"],
    component: Feedback,
  },
  {
    path: "/create-task-status",
    exact: true,
    name: "Create Task Status",
    permission: ["user"],
    component: CreateTaskStatus,
  },
  {
    path: "/manage-created-tasks",
    exact: true,
    name: "Manage Created Tasks",
    permission: ["user"],
    component: ManageCreatedTasks,
  },
  {
    path: "/all-submissions",
    exact: true,
    name: "All Submissions",
    permission: ["user"],
    component: AllSubmissions,
  },
  {
    path: "/created-task-history",
    exact: true,
    name: "Created Task History",
    permission: ["user"],
    component: CreatedTaskHistory,
  },
  {
    path: "/my-profile/add-social-media-handle",
    exact: true,
    name: "Add Social Media Handle",
    permission: ["user"],
    component: AddSocialMediaHandle,
  },
  {
    path: "/:taskProfile/:taskSubProfile/:taskId",
    exact: true,
    name: "Individual Task",
    permission: ["user"],
    component: IndividualTask,
  },
  {
    path: "/stake-points",
    exact: true,
    name: "Stake Points",
    permission: ["user"],
    component: StakePoints,
  },
  {
    path: "/notification",
    exact: true,
    name: "Notification",
    permission: ["user"],
    component: NotificationScreen,
  },
  {
    path: "/prediction",
    exact: true,
    name: "Trading",
    permission: ["user"],
    component: TradeHomeScreen,
  },
  {
    path: "/prediction/:leagueTitle",
    exact: true,
    name: "Live Trading",
    permission: ["user"],
    component: TradeLiveScreen,
  },
  {
    path: "/prediction/:leagueSlug/:eventId",
    exact: true,
    name: "Live Trading",
    permission: ["user"],
    component: TradeLeagueScreen,
  },
  {
    path: "/prediction/:leagueSlug/:eventId/detail-prediction",
    exact: true,
    name: "Detail Prediction",
    permission: ["user"],
    component: DetailTradeScreen,
  },
  {
    path: "/poll-participation-history",
    exact: true,
    name: "Live Trading",
    permission: ["user"],
    component: PollParticipationHistory,
  },
  {
    path: "/buyReferral",
    exact: true,
    name: "Buy Referral",
    permission: ["user"],
    component: buyReferrals,
  },
  {
    path: "/referral-purchase-history",
    exact: true,
    name: "Referral Purchase History",
    permission: ["user"],
    component: ReferralPurchaseHistory,
  },
  {
    path: "/point-analytics",
    exact: true,
    name: "Point Analytics",
    permission: ["user"],
    component: PointAnalytics,
  },

  {
    path: "/withdraw/SubmitWithdrawProof",
    exact: true,
    name: "SubmitWithdrawProof",
    permission: ["user"],
    component: SubmitWithdrawProof,
  },
  {
    path: "/withdraw/sendWithdraw",
    exact: true,
    name: "SendWithdrawAmount",
    permission: ["user"],
    component: SendWithdraw,
  },
  {
    path: "/buy-referral",
    exact: true,
    name: "Buy Referral",
    permission: ["user"],
    component: BuyReferralPage,
  },
  {
    path: "/TaskChat",
    name: "Task Chat",
    permission: ["user"],
    component: TaskChat,
  },
  {
    path: "/ChatWithCreator",
    name: "Chat With Creator",
    permission: ["user"],
    component: ChatWithCreator,
  },
  {
    path: "/ChatAsCreator",
    name: "Chat As Creator",
    permission: ["user"],
    component: ChatAsCreator,
  },
  {
    path: "/ActiveRefferedUsers",
    name: "Active Referral Users",
    permission: ["user"],
    component: ActiveRefferUsers,
  },
  {
    path: "/social",
    exact: true,
    name: "Social Feed",
    permission: ["user"],
    component: Social,
  },
  {
    path: "/comments/:postId",
    exact: true,
    name: "Social Comments",
    permission: ["user"],
    component: SocialComments,
  },
  {
    path: "/thread/:postId",
    exact: true,
    name: "Social Thread",
    permission: ["user"],
    component: SocialThread,
  },

  {
    path: "/social/profile/:username/approved-platforms",
    exact: true,
    name: "User Approved Platforms",
    permission: ["user"],
    component: SocialUserProfile,
  },
  {
    path: "/social/profile/approved-platforms",
    exact: true,
    name: "My Approved Platforms",
    permission: ["user"],
    component: SocialUserProfile,
  },

  {
    path: "/social/profile/:username",
    exact: true,
    name: "Social User Profile",
    permission: ["user"],
    component: SocialUserProfile,
  },

  {
    path: "/social/search",
    exact: true,
    name: "Social Search",
    permission: ["user"],
    component: SocialSearchScreen,
  },

  {
    path: "/social/profile/:username/:type",
    exact: true,
    name: "Follow List",
    permission: ["user"],
    component: FollowListPage,
  },

  // User-to-User Chat Routes
  {
    path: "my-chats",
    exact: true,
    name: "My Chats",
    permission: ["user"],
    component: AllUserChatsScreen,
  },
  {
    path: "user-chat",
    exact: true,
    name: "User Chat",
    permission: ["user"],
    component: UserToUserChatScreen,
  },

  // Platform Listing Web Routes
  {
    path: "/platform-listing",
    exact: true,
    name: "Platform Listing",
    permission: ["user"],
    component: PlatformListing,
  },
  {
    path: "/platform-listing/add",
    exact: true,
    name: "Add New Platform",
    permission: ["user"],
    component: AddNewPlatform,
  },
  {
    path: "/platform-listing/complete-details",
    exact: true,
    name: "Complete Platform Details",
    permission: ["user"],
    component: CompletePlatformDetails,
  },
  {
    path: "/platform-listing/preview",
    exact: true,
    name: "Review & Preview Platform",
    permission: ["user"],
    component: ReviewPlatformPreview,
  },
  {
    path: "/platform-listing/details/:platformId",
    exact: true,
    name: "Platform Details",
    permission: ["user"],
    component: PlatformDetails,
  },
  {
    path: "/platform-listing/add-referral/:platformId",
    exact: true,
    name: "Add Referral Link",
    permission: ["user"],
    component: AddReferralLink,
  },
  {
    path: "/platform-listing/referrals/:platformId",
    exact: true,
    name: "Platform Referral Links",
    permission: ["user"],
    component: PlatformReferralLinksList,
  },
  {
    path: "/platform-listing/my-referrals",
    exact: true,
    name: "My Referral Links",
    permission: ["user"],
    component: MyReferralLinks,
  },
  {
    path: "/platform-listing/portfolio",
    exact: true,
    name: "User Portfolio",
    permission: ["user"],
    component: UserPortfolio,
  },
  {
    path: "/platform-listing/chat/:platformId",
    exact: true,
    name: "Platform Chat",
    permission: ["user"],
    component: CommunityChat,
  },

];
// SubmitWithdrawProof
